// extracted by mini-css-extract-plugin
module.exports = {"Code":"code-block_Code__lk97H"};